export default __webpack_public_path__ + "static/media/7-brew.0efe832b.png";